import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { useEventCallback } from '@gitbook/util-react-hooks';

/**
 * Watch form values and call the given callback when they change.
 */
export function useWatchForm(
    /**
     * Callback to call when form values change.
     */
    onChange: (values: Record<string, any>) => void
) {
    const { watch } = useFormContext();
    const notifyChange = useEventCallback(onChange);
    React.useEffect(() => {
        const subscription = watch(notifyChange);
        return () => subscription.unsubscribe();
    }, [watch, notifyChange]);
}

export type FormWatcherProps = {
    /**
     * Callback to call when form values change.
     */
    onChange: (values: Record<string, any>) => void;
};

/**
 * Watch form values and call the given `onChange` callback when they change.
 */
export function FormWatcher(props: FormWatcherProps) {
    useWatchForm(props.onChange);
    return null;
}
